var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.5H10.5V15.75C10.5 12 13.5 9 17.25 9C21 9 24 12 24 15.75V25.5ZM27 24V15.75C27 11.145 23.79 7.29 19.5 6.27V5.25C19.5 4.65326 19.2629 4.08097 18.841 3.65901C18.419 3.23705 17.8467 3 17.25 3C16.6533 3 16.081 3.23705 15.659 3.65901C15.2371 4.08097 15 4.65326 15 5.25V6.27C10.695 7.29 7.5 11.145 7.5 15.75V24L4.5 27V28.5H30V27L27 24ZM17.25 33C18.0456 33 18.8087 32.6839 19.3713 32.1213C19.9339 31.5587 20.25 30.7956 20.25 30H14.25C14.25 30.7956 14.5661 31.5587 15.1287 32.1213C15.6913 32.6839 16.4544 33 17.25 33Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.c06bcfa344cbfc9c55615aa511ec2775.svg";
export { ForwardRef as ReactComponent };